export var OptInStatus;
(function (OptInStatus) {
    OptInStatus["OptedIn"] = "OPTED_IN";
    OptInStatus["OptedOut"] = "OPTED_OUT";
})(OptInStatus || (OptInStatus = {}));
export var InviteStatus;
(function (InviteStatus) {
    InviteStatus["Invitee"] = "INVITEE";
    InviteStatus["Inviter"] = "INVITER";
    InviteStatus["Both"] = "BOTH";
})(InviteStatus || (InviteStatus = {}));
export var UserStatus;
(function (UserStatus) {
    UserStatus["Unverified"] = "UNVERIFIED";
    UserStatus["Unregistered"] = "UNREGISTERED";
    UserStatus["Registered"] = "REGISTERED";
    UserStatus["Invited"] = "INVITED";
    UserStatus["Completed"] = "COMPLETED";
})(UserStatus || (UserStatus = {}));
export var ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
    ErrorCodes["UNAUTHORIZED"] = "UNAUTHORIZED";
    ErrorCodes["CAMPAIGN_NOT_FOUND"] = "CAMPAIGN_NOT_FOUND";
    ErrorCodes["CAMPAIGN_NOT_ACTIVE"] = "CAMPAIGN_NOT_ACTIVE";
    ErrorCodes["INVALID_CODE"] = "INVALID_CODE";
    ErrorCodes["BAD_REQUEST"] = "BAD_REQUEST";
    ErrorCodes["ALREADY_ENTITLED"] = "ALREADY_ENTITLED";
    ErrorCodes["MAX_REDEEMED_CODE"] = "MAX_REDEEMED_CODE";
    ErrorCodes["SUBJECT_INVALID"] = "SUBJECT_INVALID";
    ErrorCodes["COUNTRY_FORBIDDEN"] = "COUNTRY_FORBIDDEN";
    ErrorCodes["MISSING_ENTITLEMENT"] = "MISSING_ENTITLEMENT";
    ErrorCodes["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    ErrorCodes["RATE_LIMIT"] = "RATE_LIMIT";
})(ErrorCodes || (ErrorCodes = {}));
//# sourceMappingURL=enums.js.map